import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import archLogo from '../assets/arch-logo.png';
import './Login.css';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await login(email, password);
      navigate('/');
    } catch (e: any) {
      setError(e?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="tv-login-page">
      <div className="tv-login-container">
        <div className="tv-login-card">
          <div className="tv-login-brand">
            <img
              src={archLogo}
              alt="Attractis"
              className="tv-login-logo"
              decoding="async"
            />
            <h1 className="tv-login-title">Attractis</h1>
            <p className="tv-login-subtitle">Table Vision</p>
          </div>

          <form onSubmit={onSubmit} className="tv-login-form">
            <div className="tv-input-group">
              <label className="tv-input-label" htmlFor="tv-email">Email</label>
              <input
                id="tv-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="tv-input"
                placeholder="you@example.com"
                required
                autoFocus
                autoComplete="email"
                disabled={loading}
              />
            </div>

            <div className="tv-input-group">
              <label className="tv-input-label" htmlFor="tv-password">Password</label>
              <input
                id="tv-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="tv-input"
                placeholder="••••••••"
                required
                autoComplete="current-password"
                disabled={loading}
              />
            </div>

            {error && <div className="tv-login-error">{error}</div>}

            <button
              type="submit"
              className="tv-login-btn"
              disabled={loading}
            >
              {loading ? 'Signing in…' : 'Sign in'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
